/**
 * PortalMismatchDialog
 *
 * Shown after a login attempt lands on the WRONG portal for a user:
 *   • Restricted-state user logged in via /auth   → must use /signup/:state
 *   • Standard user logged in via /signup/:state  → must use /auth
 *   • Restricted-state user logged in via another state's /signup
 *
 * Renders a blocking modal with one CTA: "Click here to be redirected".
 */
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from './ui/button';

export const PortalMismatchDialog = ({ open, redirectTo, onRedirect }) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/60 p-4"
      data-testid="portal-mismatch-dialog"
    >
      <div className="w-full max-w-md rounded-2xl bg-white dark:bg-[#1a1a1a] shadow-2xl p-6 text-center">
        <div className="w-12 h-12 mx-auto rounded-full bg-red-500/15 flex items-center justify-center mb-3">
          <AlertTriangle className="w-6 h-6 text-red-600" />
        </div>
        <h2 className="text-lg font-bold mb-1">Wrong portal</h2>
        <p className="text-sm text-muted-foreground mb-5">
          This is not the correct login portal for your organization. Click here to be redirected.
        </p>
        <Button
          onClick={onRedirect}
          className="w-full rounded-full bg-[#586D52] hover:bg-[#4a5d46] text-white"
          data-testid="portal-mismatch-redirect-btn"
          disabled={!redirectTo}
        >
          Click here to be redirected
        </Button>
      </div>
    </div>
  );
};

export default PortalMismatchDialog;
